import { createReducer, createActions } from 'reduxsauce';

const { Creators, Types } = createActions({
  showMessage: ['message', 'isError'],
  hideMessage: []
});

export const INITIAL_STATE = {
  message: '',
  errorMessage: '',
  showMessage: false,
  isError: false
};

export const messageTypes = Types;
export default Creators;

const showMessage = (state, { message, isError }) => ({
  ...state,
  showMessage: true,
  message,
  isError
})

const hideMessage = (state) => ({
  ...state,
  showMessage: false,
  message: ''
});

export const reducer = createReducer(INITIAL_STATE, {
  [Types.SHOW_MESSAGE]: showMessage,
  [Types.HIDE_MESSAGE]: hideMessage
})